import { Injectable, signal } from '@angular/core';
import { ILazyComponentHandler } from 'src/app/models/smart-actions.models';

@Injectable({
    providedIn: 'root'
})
export class LazyLoadersRegistrationService {

    private readonly map = signal<Map<string, ILazyComponentHandler>>(new Map());

    constructor() { }

    register(key: string, handler: ILazyComponentHandler) {
        this.map.update(currentMap => {
            const newMap = new Map(currentMap);
            newMap.set(key, handler);
            return newMap;
        });
    }

    unregister(key: string) {
        this.map.update(currentMap => {
            const newMap = new Map(currentMap);
            newMap.delete(key);
            return newMap;
        });
    }

    registrations(){
        return Array.from(this.map().keys());
    }

    getLoader(key: string) {
        return this.map().get(key) ?? null;
    }
}
